export default __webpack_public_path__ + "812c705e8be1b2767f518e22cc3be348.jpg";